import React from "react";

export default function SetupCard({ icon, index, title, items, duration, items_style, title_style }) {

    return (
        <div className="inline-flex flex-col items-center relative flex-[0_0_auto] h-full">
            <div className="inline-flex items-center justify-center w-full xl:w-[180px] h-auto xl:h-[180px] bg-white rounded-[50%] shadow-[0px_2px_4px_1px_#caa88b] xl:mt-[-20px]">
                <div className="w-full xl:w-[140px] h-auto xl:h-[140px] bg-[#d3aa86] rounded-[50%] inline-flex items-center justify-center">
                    <img
                        className="absolute w-full h-auto xl:w-[40%] "
                        alt={title}
                        src={icon}
                    />
                </div>
                
                {index%2==0?
                <hr className="absolute h-[4px] w-[20px] top-[185px] bg-[#d3aa86] border-[#d3aa86] rotate-[90deg]" />
                :
                <hr className="absolute h-[4px] w-[40px] top-[180px] bg-[#d3aa86] border-[#d3aa86] rotate-[90deg]" />
                }

                <div className="top-0 xl:top-[215px] absolute flex flex-col items-center justify-between h-auto xl:h-[355px]">
                    <div className="flex flex-col items-center gap-4">
                        <div className={`w-full text-left text-[#d3aa86] text-2xl font-bold font-['Open Sans'] flex justify-center items-center xl:h-[80px] xl:mb-[10px] ${title_style}`}>
                            {title}
                        </div>
                        <div className={`w-full flex-col justify-start items-left gap-2 xl:gap-[13px] inline-flex ${items_style}`}>
                            {items.map((item, index) => (
                                <div key={index} className="self-stretch text-left text-[#544a28] text-xs font-normal font-['Open Sans']">
                                    {item}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="text-center text-base leading-normal xl:text-[32px] xl:leading-[44.8px] font-bold font-['Inter'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text flex items-end">
                        {duration}
                    </div>
                </div>
            </div>
        </div>
    );
} 